/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export type DocumentStatusEnum = 'good' | 'bad' | 'unchecked' | '11184809';

export const DocumentStatusEnum = {
  GOOD: 'good' as DocumentStatusEnum,
  BAD: 'bad' as DocumentStatusEnum,
  UNCHECKED: 'unchecked' as DocumentStatusEnum,
  UNKNOWN_DEFAULT_OPEN_API: '11184809' as DocumentStatusEnum
};
